import React from 'react';

const Loading = () => (
    <i className="fa fa-fw fa-spin fa-spinner" />
);

export default Loading;
